import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=8d7e6e2a&"
import script from "./SubmitBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=8d7e6e2a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports